import NavMenu from "./menu";
//import ibrahim from "../../images/ibrahim-transparent.png";
//import bg from "../../images/bgblue.png"
import "./index.css";


function HeadSection(){

	

	return(
		<header id='headman'>
			<section id="heads">
				<div className='side minor'>

					<h1 className='hollywood'>Full Stack Web Developer <br /> I Code, Build And Design!</h1>

					<p className='spiral'>
					    I help individuals and businesses develop fascinating and secured websites and web applications.					    
					</p>

				</div>

				<div className='side major'>
					<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/ibrahim-transparent.webp" 
						alt="Ibrahim B. Oduola, freelancing web developer" 
						srcSet="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/ibrahim-transparent-480p.webp 480w, https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/ibrahim-transparent.webp" 
						sizes="(max-width: 600px) 480px, 800px"
						/>
				</div>

				<NavMenu />

			</section>
			
			

		</header>


		)
};

export default HeadSection;
